<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: "",
    required: false,
    validator(value) {
      return ["primary", "secondary", "success", "danger", "info", "secondary-success", "secondary-danger", "secondary-info", ""].includes(value)
    }
  }
})

</script>
<template>
  <span
      class="leading-none inline-flex items-center justify-center rounded-full px-3 py-1 whitespace-nowrap transition-all text-[0.6rem] uppercase font-semibold"
      :class="
        {
          // Variants primary
          'bg-brand-primary': variant === 'primary',
          'bg-darken-brand-primary text-brand-primary': variant === 'secondary',
          'bg-green-500': variant === 'success',
          'bg-red-500': variant === 'danger',
          'bg-yellow-500': variant === 'warning',
          'bg-blue-500': variant === 'info',

          // Variants secondary
          'bg-green-500/10 text-green-500': variant === 'secondary-success',
          'bg-red-500/10 text-red-500': variant === 'secondary-danger',
          'bg-yellow-500/10 text-yellow-500': variant === 'secondary-warning',
          'bg-blue-500/10 text-blue-500': variant === 'secondary-info',
        }
      "
  >
      <slot/>
  </span>
</template>
